<template lang="pug">
.form.center.w512
  .card
    .top
      .left
        .card-headline Layout definieren
        .card-description Fügen Sie Überschriften oder Input-Blöcke hinzu, um das Formular zu gestalten.
      .margin-top
      
      template(v-for="block, idx in layout")
        .builder-block(v-if="block.type === 'headline'")
          h2.title.is-6 {{block.value}}
          b-button(type="is-danger" icon-left="delete"
                  @click="removeField(idx)")

        .builder-block(v-else)
          template(v-if="block.value.length === 1")
            b-field(v-for="value in block.value" :key="value.dbName" :label="value.name" label-position="on-border")
              b-input(:placeholder="value.dbName")
          
          b-field(v-else grouped)
            b-field(v-for="value in block.value" :key="value.dbName" :label="value.name" label-position="on-border")
              b-input(:placeholder="value.dbName")
          
          .button-wrapper
            //- b-button(type="is-primary" icon-left="pencil-outline"
                    @click="editField(idx)")
            b-button(type="is-danger" icon-left="delete"
                    @click="removeField(idx)")

      .button-wrapper
        b-button(type="is-primary" icon-left="content-save" @click="$emit('save')") Speichern
        b-button(type="is-light" icon-left="format-title" @click="openModal('headline')") Neue Überschrift
        b-button(type="is-light" icon-left="view-column" @click="openModal('block')") Neuer Block

  // Here are all modals
  b-modal(:active.sync="showHeaderModal"
                    has-modal-card
                    trap-focus
                    aria-role="dialog"
                    aria-modal
                    ref="modal1")
    form(action='')
      .modal-card(style="width: auto")
        header.modal-card-head
          p.modal-card-title Neue Überschrift
        section.modal-card-body
          b-field
            b-input(type="text"
                    value=""
                    required
                    ref="modal-headline")
        footer.modal-card-foot
          b-button(type="is-light" @click="$refs.modal1.close()") Abbrechen
          b-button(type="is-primary" @click="addHeadline()") Hinzufügen

  b-modal(:active.sync="showBlockModal"
          has-modal-card
          trap-focus
          aria-role="dialog"
          aria-modal
          ref="modal2")
    form(action='')
      .modal-card(style="width: auto")
        header.modal-card-head
          p.modal-card-title Neuer Block
        section.modal-card-body
          b-field(label="Spaltenanzahl" label-position="on-border")
            b-select(v-model="modalColumns")
              option(:value="1") 1 Spalte
              option(:value="2") 2 Spalten
          b-field(grouped v-for="column, idx in modalColumns" :key="idx")
            b-field(label="Feldname" label-position="on-border")
              b-input(required :ref="`name-${idx}`")
            b-field(label="Datenbankfeld" label-position="on-border")
              b-select(required :ref="`dbName-${idx}`")
                option(v-for="c in filteredColumns" :value="c") {{c}}
        footer.modal-card-foot
          b-button(type="is-light" @click="$refs.modal2.close()") Abbrechen
          b-button(type="is-primary" @click="addBlock()") Hinzufügen
</template>

<script>
export default {
  props: {
    layout: {
      type: Array,
      default() {
        return [];
      }
    },
    columns: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      modalColumns: 1,
      showHeaderModal: false,
      showBlockModal: false,
      activeBlockId: null
    };
  },
  computed: {
    filteredColumns() {
      let newList = [...this.columns];
      for (let a = 0; a < this.layout.length; a += 1) {
        if (this.layout[a].type === "headline") continue;

        for (let b = 0; b < this.layout[a].value.length; b += 1) {
          for (let c = 0; c < newList.length; c += 1) {
            if (this.layout[a].value[b].dbName === newList[c]) {
              newList.splice(c, 1);
            }
          }
        }
      }
      return newList;
    }
  },
  methods: {
    openModal(name) {
      if (name === "headline") {
        this.showHeaderModal = true;
      } else {
        this.showBlockModal = true;
      }
    },
    addHeadline() {
      this.$emit("add", {
        type: "headline",
        value: this.$refs["modal-headline"].newValue
      });
      this.$refs.modal1.close();
    },
    addBlock() {
      const columns = [];
      for (let i = 0; i < this.modalColumns; i += 1) {
        const name = this.$refs["name-" + i][0].newValue;
        const dbName = this.$refs["dbName-" + i][0].selected;
        columns.push({ name, dbName });
      }

      this.$emit("add", {
        type: this.modalColumns + "-column",
        value: columns
      });
      this.$refs.modal2.close();
    },
    removeField(idx) {
      this.$emit("remove", idx);
    },
    editField(idx) {
      this.$emit("edit", idx);
    }
  }
};
</script>

<style lang="scss" scoped>
.form-builder {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;

  .builder-block {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .button-wrapper {
      margin-left: $sm-space;
    }
  }
}
</style>